import { render, staticRenderFns } from "./huati.vue?vue&type=template&id=4d721f03&scoped=true"
import script from "./huati.vue?vue&type=script&lang=js"
export * from "./huati.vue?vue&type=script&lang=js"
import style0 from "./huati.vue?vue&type=style&index=0&id=4d721f03&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d721f03",
  null
  
)

export default component.exports